import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss'; //NOSONAR

const ProductsQuantity = (props) => {
    
    const {quantity, text} = props;
    const pluralize = quantity === 1 ? 'producto' : 'productos';

    return (
        <span className={'new-products-quantity-span' + ((quantity > 0) ? ' active': '')}>{quantity !== 0 ? quantity : '0'} {text && pluralize}</span>
    )
};

ProductsQuantity.propTypes = {
    text: PropTypes.bool,
    quantity: PropTypes.number
};

export default ProductsQuantity;
